import PopoverBtn from "../../../components/popoverBtn";
import {Arrow} from "./svg";
import { ArrowDiv, InternalCard } from ".";
import React from "react";

const GenerateCard = ({ data, handlerTargetCard, CardTypeQr }) => {
  return (
    <InternalCard
      key={data.index}
      className="d-flex align-items-center bg-white header-item cursor-pointer rounded-4 border-1 border-border-gray border px-lg-4 px-3"
      onClick={() => handlerTargetCard(data.nav, data.redirect, data.title)}
    >
      <div className="d-flex align-items-center w-100 justify-content-between cursor-pointer">
        <div className="d-flex overflow-hidden">
          <div className="d-flex align-items-center pe-2 cursor-pointer">
            {data.img ? <data.img /> : data.icon}
          </div>
          <div className="cursor-pointer itemTitle d-flex align-items-center">
            {data.title}
          </div>
        </div>
        <div className="d-flex align-items-center">
          {data.showPopover ? (
            <div className={`cursor-pointer me-3`}>
              <PopoverBtn text={CardTypeQr[data.index].name} />
            </div>
          ) : null}
          <ArrowDiv>
            <Arrow />
          </ArrowDiv>
        </div>
      </div>
    </InternalCard>
  );
};

export default GenerateCard
